import { render, staticRenderFns } from "./ExternalClubDetail.vue?vue&type=template&id=99a7902e&scoped=true&"
import script from "./ExternalClubDetail.vue?vue&type=script&lang=ts&"
export * from "./ExternalClubDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalClubDetail.vue?vue&type=style&index=0&id=99a7902e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7902e",
  null
  
)

export default component.exports